"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLatestEncodings = exports.isValidBlueprint = exports.getBlueprintHashFromState = exports.getBlueprintHash = exports.buildBlueprint = void 0;
var md5 = require("md5");
var language_fallback_1 = require("../language-fallback");
var object_helpers_1 = require("../object-helpers");
function buildBlueprint(_a) {
    var compositionBlocks = _a.compositionBlocks, allBlocks = _a.allBlocks, audioDelay = _a.audioDelay, thumbnailSrc = _a.thumbnailSrc, blockListId = _a.blockListId, name = _a.name, language = _a.language, tags = _a.tags;
    var blocks = compositionBlocks.map(function (bl) {
        var _a, _b, _c, _d;
        var matchingBlock = allBlocks.find(function (b) { return b._id === bl.blockId; });
        if (!matchingBlock) {
            return undefined;
        }
        var matchingVideo = (0, language_fallback_1.matchLanguageOrFallback)(matchingBlock.videos, language, bl.videoVariation);
        var matchingSpeak = (0, language_fallback_1.matchLanguageOrFallback)(matchingBlock.speaks, language, bl.speakVariation);
        return {
            metadata: {
                blockId: bl.blockId,
                name: matchingBlock.name,
                video: {
                    variation: (matchingVideo === null || matchingVideo === void 0 ? void 0 : matchingVideo.variations) && (matchingVideo === null || matchingVideo === void 0 ? void 0 : matchingVideo.variations[0]),
                    language: matchingVideo === null || matchingVideo === void 0 ? void 0 : matchingVideo.language,
                    duration: (_a = matchingVideo === null || matchingVideo === void 0 ? void 0 : matchingVideo.videoFile) === null || _a === void 0 ? void 0 : _a.duration,
                },
                speak: {
                    variation: (matchingSpeak === null || matchingSpeak === void 0 ? void 0 : matchingSpeak.variations) && (matchingSpeak === null || matchingSpeak === void 0 ? void 0 : matchingSpeak.variations[0]),
                    language: matchingSpeak === null || matchingSpeak === void 0 ? void 0 : matchingSpeak.language,
                    duration: (_b = matchingSpeak === null || matchingSpeak === void 0 ? void 0 : matchingSpeak.audioFile) === null || _b === void 0 ? void 0 : _b.duration,
                    text: matchingSpeak === null || matchingSpeak === void 0 ? void 0 : matchingSpeak.text,
                },
            },
            paths: {
                video: {
                    src: (_c = matchingVideo === null || matchingVideo === void 0 ? void 0 : matchingVideo.videoFile) === null || _c === void 0 ? void 0 : _c.src,
                },
                speak: {
                    src: (_d = matchingSpeak === null || matchingSpeak === void 0 ? void 0 : matchingSpeak.audioFile) === null || _d === void 0 ? void 0 : _d.src,
                },
            },
        };
    }).filter(function (b) { return b !== undefined; });
    var body = (0, object_helpers_1.cleanupEmpty)({ blocks: blocks.map(function (b) { return b.paths; }), audioDelay: audioDelay, thumbnailSrc: thumbnailSrc });
    var hash = md5(JSON.stringify(body));
    return (0, object_helpers_1.cleanupEmpty)({
        body: body,
        header: { blockListId: blockListId, blocks: blocks.map(function (b) { return b.metadata; }), name: name, language: language, hash: hash, tags: tags },
    });
}
exports.buildBlueprint = buildBlueprint;
function getBlueprintHash(options) {
    return md5(JSON.stringify(buildBlueprint(options)));
}
exports.getBlueprintHash = getBlueprintHash;
function getBlueprintHashFromState(language, allBlocks, state) {
    return getBlueprintHash(__assign(__assign({}, state), { language: language, allBlocks: allBlocks }));
}
exports.getBlueprintHashFromState = getBlueprintHashFromState;
function isValidBlueprint(blueprint) {
    return blueprint.body.blocks
        .map(function (block) { return !!block.speak.src && !!block.video.src; })
        .reduce(function (a, b) { return !a ? false : b; });
}
exports.isValidBlueprint = isValidBlueprint;
function getLatestEncodings(encodings) {
    var sorted = (encodings === null || encodings === void 0 ? void 0 : encodings.sort(function (a, b) { return b.output.lastModified - a.output.lastModified; })) || [];
    var output = {};
    sorted.forEach(function (encoding) {
        if (!output[encoding.input.header.language]) {
            output[encoding.input.header.language] = encoding;
        }
    });
    return output;
}
exports.getLatestEncodings = getLatestEncodings;
//# sourceMappingURL=blueprint-helpers.js.map